import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';
import Tooltip from '@atlaskit/tooltip';
import React from 'react';
import { Link as RouteLink } from 'react-router-dom';
import { EMPTY_STATE } from '../PartnerReports.constants';
import { getReportsContainerWidth } from '../PartnerReports.utils';
import { Action } from '../ReportsFilters/filtersOptions';
export const FeedbackDetailsHeader = enableSenDeprecationChanges => {
  const reportsContainerWidth = getReportsContainerWidth();
  const fieldsToDisplayUponSenDeprecation = [{
    key: 'licenseIdEntitlementNumber',
    content: /*#__PURE__*/React.createElement(React.Fragment, null, "License ID/Entitlement number", /*#__PURE__*/React.createElement(Tooltip, {
      content: /*#__PURE__*/React.createElement(React.Fragment, null, "From Nov 30, 2023, for all cloud licenses, Entitlement Number (EN) has replaced SEN.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        href: "https://atlassianpartners.atlassian.net/wiki/spaces/resources/pages/283312506/Marketplace+Partners%3A+New+date+for+replacement+of+SEN+on+the+new+billing+engine-+Quick+Reference+Guide?atlOrigin=eyJpIjoiZjNjZjZkN2MyNDg3NDIwNmE4MDkzMTE4NGZiNmY2NTEiLCJwIjoiY29uZmx1ZW5jZS1jaGF0cy1pbnQifQ",
        style: {
          color: 'inherit'
        },
        rel: "noreferrer"
      }, /*#__PURE__*/React.createElement("u", null, "Read more")))
    }, /*#__PURE__*/React.createElement(EditorPanelIcon, {
      label: ""
    }))),
    width: reportsContainerWidth * 0.19
  }];
  const fieldsToDisplayBeforeSenDeprecation = [{
    key: 'licenseId',
    content: 'License ID',
    width: reportsContainerWidth * 0.16
  }];
  /** Divider ReportsContainer width which is equal to 1040px
   * splitted this ReportsContainer width proportionally according to content
   * for each column
   */
  return {
    cells: [{
      key: 'date',
      content: 'Feedback date',
      width: reportsContainerWidth * 0.16
    }, ...(enableSenDeprecationChanges ? fieldsToDisplayUponSenDeprecation : fieldsToDisplayBeforeSenDeprecation), {
      key: 'appName',
      content: 'App name',
      width: reportsContainerWidth * 0.18
    }, {
      key: 'appVersion',
      content: 'App version',
      width: reportsContainerWidth * 0.12
    }, {
      key: 'action',
      content: 'Action',
      width: reportsContainerWidth * 0.16
    }, {
      key: 'reason',
      content: 'Reason',
      width: enableSenDeprecationChanges ? reportsContainerWidth * 0.19 : reportsContainerWidth * 0.22
    }]
  };
};
export const getFeedbackDetailsBody = (feedbackDetails, getReportsLink, fireEvent, enableSenDeprecationChanges) => {
  if (!feedbackDetails) {
    return [];
  }
  const reportsContainerWidth = getReportsContainerWidth();
  return feedbackDetails.map((feedback, index) => {
    var _Action$find;
    return {
      key: feedback.licenseId,
      itemId: "item".concat(index + 1),
      children: [{
        isChild: true,
        value: feedback,
        report: 'feedback'
      }],
      cells: [{
        key: feedback.date,
        content: feedback.date,
        width: reportsContainerWidth * 0.16
      }, {
        key: feedback.appEntitlementNumber || feedback.licenseId,
        content: /*#__PURE__*/React.createElement(RouteLink, {
          to: getReportsLink('text', enableSenDeprecationChanges ? feedback.appEntitlementNumber || feedback.licenseId : feedback.licenseId, 'licenseId'),
          onClick: () => fireEvent('text'),
          "data-testid": "license-id-".concat(index + 1)
        }, enableSenDeprecationChanges ? feedback.appEntitlementNumber || feedback.licenseId : feedback.licenseId),
        width: enableSenDeprecationChanges ? reportsContainerWidth * 0.19 : reportsContainerWidth * 0.16
      }, {
        key: feedback.addonName,
        content: /*#__PURE__*/React.createElement(RouteLink, {
          to: getReportsLink('addon', feedback.addonKey),
          onClick: () => fireEvent('addon', feedback.addonKey),
          "data-testid": "app-name-".concat(index + 1)
        }, feedback.addonName),
        width: reportsContainerWidth * 0.18
      }, {
        key: feedback.addonVersion,
        content: feedback.addonVersion === '' ? EMPTY_STATE : feedback.addonVersion,
        width: reportsContainerWidth * 0.12
      }, {
        key: feedback.feedbackType,
        content: (_Action$find = Action.find(item => item.value === feedback.feedbackType)) === null || _Action$find === void 0 ? void 0 : _Action$find.label,
        width: reportsContainerWidth * 0.16
      }, {
        key: feedback.reason,
        content: feedback.reason,
        width: enableSenDeprecationChanges ? reportsContainerWidth * 0.19 : reportsContainerWidth * 0.22
      }]
    };
  });
};